export default __webpack_public_path__ + "2fb8b48a20a0431896d670e15618689a.png";